import React from 'react';

import { Tracking as TrackingProto } from 'proto/Tracking/Tracking';

import TrackingElement from './__partials/TrackingElement';
import { TrackingType } from './types';

interface TrackingProps {
    tracking?: TrackingProto;
}

const Tracking = ({ tracking }: TrackingProps) => {
    const generalTracking = tracking?.generalTracking;
    const travelTracking = tracking?.travelTracking;

    return (
        <>
            {generalTracking && (
                <TrackingElement
                    data={generalTracking}
                    type={TrackingType.General}
                />
            )}
            {travelTracking && (
                <TrackingElement
                    data={travelTracking}
                    type={TrackingType.Travel}
                />
            )}
        </>
    );
};

export default Tracking;
